import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { AddScorecardDispute } from '../addScorecardDispute/AddScorecardDispute';
import './scorecardDisputesTable.scss';
import { exportExcel, statusIcon } from './scorecard-disputes-table-service';
import { DateTemplate } from '../dateTemplate/DateTemplate';

interface DisputesPropTypes {
    scorecardVersion?: number;
    data?: any[];
    isSubTab?: boolean;
    isMangerWindowOpen?: boolean;
}
export const ScorecardDisputesTable = ({
    scorecardVersion,
    data,
    isSubTab,
    isMangerWindowOpen,
}: DisputesPropTypes) => {
    const [addDisputeDialogEnable, setAddDisputeDialogEnable] = useState<boolean>(false);
    const [selectedScorecardDisputes, setSelectedScorecardDisputes] = useState<any>([]);
    const [dipsuteIds, setDisputeIds] = useState<any>([]);
    const [disableDisputeDetails, setDisableDisputeDetails] = useState(false);
    const [selectedRowdata, setSelectedRowdata] = useState<any>(null);
    const [mode, setMode] = useState<any>(null);
    const addDisputeButtonOnclick = () => {
        if (isMangerWindowOpen) {
            toast.warn('Sorry, you cannot create a dispute once the approval window has started.');
            return;
        }
        setAddDisputeDialogEnable(true);
        setDisableDisputeDetails(false);
        setMode('add');
    };
    const resolveDisputeButtonOnclick = () => {
        setAddDisputeDialogEnable(true);
        setDisableDisputeDetails(true);
        setMode('resolve');
    };
    const closeAddDisputes = (message: boolean) => {
        setAddDisputeDialogEnable(message);
    };
    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                {isSubTab ? <div className="scDisputesTitle">Open Disputes</div> : ''}
                <div className="float-end">
                    {window.localStorage.EnableAddDispute === 'true' && !isSubTab ? (
                        <>
                            <Button
                                type="button"
                                onClick={addDisputeButtonOnclick}
                                className="btn-primary me-2"
                                label="Add Dispute"
                                icon="pi pi-plus-circle"
                                disabled={selectedScorecardDisputes?.length > 0}
                            />
                            <Button
                                type="button"
                                onClick={resolveDisputeButtonOnclick}
                                className="btn-primary me-2"
                                label="Resolve Dispute"
                                icon="pi pi-check-circle"
                                disabled={selectedScorecardDisputes?.length < 1}
                            />
                            <Button
                                type="button"
                                icon="pi pi-upload me-2"
                                className="btn-export me-2"
                                onClick={() => {
                                    exportExcel(data);
                                }}
                                data-pr-tooltip="XLS"
                            >
                                Export
                            </Button>
                        </>
                    ) : (
                        ''
                    )}
                    {isSubTab ? (
                        <Button
                            type="button"
                            onClick={resolveDisputeButtonOnclick}
                            className="btn-primary me-2"
                            label="Resolve Dispute"
                            icon="pi pi-check-circle"
                            disabled={selectedScorecardDisputes?.length < 1}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    };
    const header = renderHeader();
    const statusIndicator = (rowData: any) => {
        const icon = statusIcon(rowData);
        return (
            <div>
                {icon ? (
                    <img
                        className="justify-content-left "
                        src={icon}
                        alt={rowData.disputeStatusID === 1 ? 'disputed' : 'resolved'}
                    />
                ) : (
                    ''
                )}
            </div>
        );
    };
    const onSelectionChange = (event: any) => {
        window.localStorage.unCheckIt = false;
        setSelectedScorecardDisputes(event.value);
        const disputeId = event.value.map((x: any) => x.dispute_id);
        setDisputeIds(disputeId);
        setSelectedRowdata(event.value[0]);
    };
    useEffect(() => {
        if (window.localStorage.unCheckIt === 'true') {
            setDisputeIds([]);
            setSelectedRowdata(null);
            setSelectedScorecardDisputes([]);
        }
    }, [window.localStorage.unCheckIt]);
    const isRowSelectable = (event: any) => {
        return event.data.disputeStatusID === 1;
    };

    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className="card-body p-0 align-middle text-center table">
                <AddScorecardDispute
                    scorecardVersion={scorecardVersion}
                    addDisputeDialogEnable={addDisputeDialogEnable}
                    closeAddDisputes={closeAddDisputes}
                    disableDisputeDetails={disableDisputeDetails}
                    selectedDisputesList={dipsuteIds}
                    selectedDisputeRowData={selectedRowdata}
                    mode={mode}
                    isMangerWindowOpen={isMangerWindowOpen}
                />
                <DataTable
                    value={data}
                    header={header}
                    dataKey="dispute_id"
                    className="scorecardDisputesTable"
                    selection={selectedScorecardDisputes}
                    onSelectionChange={onSelectionChange}
                    scrollable
                    scrollHeight="600px"
                    selectionMode={undefined}
                    isDataSelectable={isRowSelectable}
                    sortField="tL_name"
                    sortOrder={1}
                >
                    <Column
                        style={{ maxWidth: '3rem' }}
                        filterMenuStyle={{ width: '3em' }}
                        body={statusIndicator}
                    />
                    <Column
                        key="check"
                        selectionMode="multiple"
                        style={{ maxWidth: '3rem' }}
                        filterMenuStyle={{ width: '3em' }}
                    />
                    <Column
                        header="Name"
                        field="tL_name"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="tL_name"
                    />
                    <Column
                        header="Oracle ID"
                        field="oracleID"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="oracleID"
                    />
                    <Column
                        header="Date Added"
                        field="dateAdded"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        body={(date) => DateTemplate(date?.dateAdded)}
                        sortField="dateAdded"
                    />
                    <Column
                        header="Date of Dispute"
                        field="dateofDispute"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        body={(date) => DateTemplate(date?.dateofDispute)}
                        sortField="dateofDispute"
                    />
                    <Column
                        header="Status"
                        field="disputeStatus"
                        sortable
                        sortField="disputeStatus"
                        style={{ minWidth: '13rem' }}
                    />
                </DataTable>
            </div>
        </div>
    );
};
